@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

<p-dialog header="Apply Default Booking Fee?" [(visible)]="showDefaultFeeDialog" [style]="{width: '40vw'}" [baseZIndex]="10000" [modal]="true">
  <div><b>A default booking fee &ldquo;{{ defaultBookingFee?.name }}&rdquo; exists. Would you like to apply it to this package?</b></div>
  <ng-template #footer>
    <p-button icon="pi pi-check" label="Yes, apply booking fee" styleClass="p-button p-button-success" (click)="confirmDefaultFee()"></p-button>
    &nbsp;
    <p-button icon="pi pi-times" label="No, leave without a fee" styleClass="p-button p-button-secondary" (click)="declineDefaultFee()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="Party Package?" [(visible)]="showPartyPackageDialog" [style]="{width: '40vw'}" [baseZIndex]="10000" [modal]="true">
  <div><span class="pi pi-question-circle" style="font-size: 2.5rem;width: 75px;float: left;padding: 14px;color: #3B82F6; float:left;"></span></div>
  <div style="width:85%; float:left;"><b>This package contains the word 'party' in its name or description. Would you like to mark it as a Party Package?</b></div>
  <ng-template #footer>
    <p-button icon="pi pi-check" label="Yes, set as Party Package" styleClass="p-button p-button-success" (click)="confirmSetPartyPackage()"></p-button>
    &nbsp;
    <p-button icon="pi pi-times" label="No, leave as is" styleClass="p-button p-button-secondary" (click)="showPartyPackageDialog=false; proceedWithSave()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="Package Conflict" [(visible)]="showDialog" [style]="{width: '50vw'}" [baseZIndex]="10000"  [modal]="true">
  <div><span class="pi pi-exclamation-triangle" style="font-size: 2.5rem;width: 75px;float: left;padding: 14px;color: #EF4444;; float:left;"></span></div>
  <div style="width:85%; float:left;"><b>This package has been changed by another user, you can choose to refresh the page to see those changes or carry on - if you save your changes you will overwrite the changes that have already been made.</b></div>

  <ng-template #footer>
    <p-button icon="pi pi-refresh" label="Refresh page" styleClass="p-button p-button-success" (click)="doRefresh()"></p-button>
    &nbsp;
    <p-button icon="pi pi-times" (click)="showDialog=false" label="Continue Editing" styleClass="p-button p-button-danger"></p-button>
  </ng-template>

</p-dialog>


@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3">
        <h3>Package - {{PackageObj.name}}</h3>
        @if (PackageObj.disabled) {
          <h4 style="font-size: 22px; color: red;">This package is <b>disabled</b> - please save this package to reenable it.</h4>
        }
      </div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span> Define your package here.  It is made up of 3 sections Package Details, Resources and Admissions all 3 sections must be completed.
      </p>
      <!--<div *ngIf="id=='0'" class="surface-card p-4 shadow-2 border-round" style="margin-bottom: 20px;">
      <p-steps [model]="items"></p-steps>
    </div>-->
    <div class="surface-card p-4 shadow-2 border-round">
      <div class="grid formgrid p-fluid">
        <!-- On a phone the tabs are replaced by this - see sectionOptions. -->
        @if (isMobile) {
          <div class="col-12 cf-section-picker">
            <label class="font-medium">Section</label>
            <p-select [options]="sectionOptions" [(ngModel)]="activeIndex" optionLabel="label" optionValue="value" [style]="{'width':'100%'}">
              <ng-template let-option #item>
                <span class="pi {{option.icon}}" style="margin-right:8px;"></span>{{option.label}}
              </ng-template>
              <ng-template let-option #selectedItem>
                <span class="pi {{option.icon}}" style="margin-right:8px;"></span>{{option.label}}
              </ng-template>
            </p-select>
          </div>
        }
        <app-tabview [style]="{'width':'100%'}" [(activeIndex)]="activeIndex">
          <app-tabpanel header="Package Details" leftIcon="pi pi-box">
            <div class="field mb-4 col-12">
              <label for="packageobjname" class="font-medium">Name</label>
              <div style="clear:both;"></div>
              <input [(ngModel)]="PackageObj.name" [ngStyle]="{'border-color': (packageNameValid==false) ? '#FF0000':''}" id="packageobjname" type="text" pInputText>
            </div>
            @if (!packageNameValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Package Name.</div>
            }
            <div class="field mb-4 col-12">
              <label for="packageobjdescription" class="font-medium">Description</label>
              <p-editor [(ngModel)]="PackageObj.description" [style]="{'height':'320px'}">
                <ng-template #header>
                  <span class="ql-formats">
                    <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="small">Small</option>
                          <option selected value="normal">Normal</option>
                          <option value="large">Sub Heading</option>
                          <option value="huge">Heading</option>
                        </select>
                        <select class="ql-font">
                          <option selected value="san serif">San-Serif</option>
                          <option value="monospace">Monospace</option>
                          <option value="serif">Serif</option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                        <button class="ql-script" value="sub" title="Subscript"></button>
                        <button class="ql-script" value="super" title="Superscript"></button>
                        <button class="ql-indent" value="-1" title="Indent"></button>
                        <button class="ql-indent" value="+1" title="Outdent"></button>
                      </span>
                      <span class="ql-formats">
                        <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                        </select>
                        <span class="ql-format-separator"></span>
                        <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-list" title="Ordered" value="ordered"></button>
                        <button class="ql-list" title="Bullet" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align" >
                          <option label="Left"></option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                      </span>
                    </p-header>
                  </span>
                </ng-template>
              </p-editor>
            </div>
            @if (!packageDescValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Package Description.</div>
            }
            <div style="clear:both;width:100%">&nbsp;</div>
            <div class="field mb-4 col-12">
              <label for="packageobjFile" class="font-medium">Upload a header image for Booking Wizard. The image must be smaller than 100KB</label>
              <div style="clear:both;width:100%">&nbsp;</div>
              <p-fileupload style="float:left;margin-right:10px;" mode="basic" [auto]="true" name="image" url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="100000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload File"></p-fileupload>
              @if (FileChosen != null && FileChosen != '') {
                <button pButton pRipple type="button" style="float: left;margin-bottom: 10px;margin-top: 1px !important;height: 50px;" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeImage()">
                  <span style="margin-right:10px;" class="pi pi-times"></span>
                  Remove Image
                </button>
              }
              <div style="clear:both;width:100%">&nbsp;</div>
              @if (FileChosen != null && FileChosen != '') {
                <div>
                  <p style="margin-top:10px;">This is how your image will look in place.</p>
                  <div class="surface-card p-4 shadow-2 border-round packageCard" style="width: 460px;">
                    <div id="image">
                      <img src="{{ FileChosen }}" style="width: 460px;margin-top: -23px;margin-left: -23px;margin-right: -23px;">
                    </div>
                    <div style="font-weight: bold; padding: 20px;font-size:larger;">{{PackageObj.name}}</div>
                    <div style="padding-left: 20px; padding-right: 20px" [innerHTML]="">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                    </div>
                    <div>
                      <br><br>
                    </div>
                    <div>
                      <div>
                        <p-button label="Book this Package" icon="pi pi-check" style="width:420px;">
                        </p-button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="field mb-4 col-12">
              <label for="ispartypackage" class="font-medium">This is a Party Package:</label>
              <p-selectbutton id="ispartypackage" [options]="stateOptions" [(ngModel)]="PackageObj.ispartypackage"></p-selectbutton>
            </div>
            <div class="field mb-4 col-12">
              <label for="packageRule" class="font-medium">Confirmation</label>
              <p-select [options]="Confirmations" [(ngModel)]="PackageObj.confirmation" [(ngModel)]="PackageObj.confirmation" placeholder="Please select a confirmation" [showClear]="true" optionLabel="name"></p-select>
            </div>
            <div class="field mb-4 col-12">
              <label for="packageRule" class="font-medium">Warning</label>
              <p-select [options]="Warnings" [(ngModel)]="PackageObj.warning" placeholder="Please select a Warning" [showClear]="true" optionLabel="name"></p-select>
            </div>
            @if (WaiverActive) {
              <div class="field mb-4 col-12">
                <label for="selectionmode" class="font-medium">This Package requires a Waiver:</label>
                <p-selectbutton  id="selectionmode" [options]="stateOptions" [(ngModel)]="PackageObj.waiverrequired" ></p-selectbutton>
              </div>
            }
            <div class="field mb-4 col-12">
              <label for="selectionmode" class="font-medium">Visibility:</label>
              <p-selectbutton  id="selectionmode" class="cf-stack" [options]="stateOptionsVisibility" [(ngModel)]="PackageObj.visibility" ></p-selectbutton>
            </div>
            <div class="field mb-4 col-12">
              <label for="dpStartTime" class="font-medium">Start Date</label>
              <div style="max-width: 500px;">
                <p-datepicker [selectOtherMonths]="true" [(ngModel)]="PackageObj.startDate" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="packagestartdate" (onSelect)="onStartDateChange($event)" (onBlur)="onStartDateChange(PackageObj.startDate)"></p-datepicker>
              </div>
            </div>
            <div class="field mb-4 col-12">
              <label for="dpEndTime" class="font-medium">End Date</label>
              <div style="max-width: 500px;">
                <p-datepicker [selectOtherMonths]="true" [ngModel]="PackageObj.endDate" (ngModelChange)="onEndDateChange($event)" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="packageenddate" [minDate]="PackageObj.startDate" (onBlur)="onEndDateChange(PackageObj.endDate)"></p-datepicker>
              </div>
            </div>
            <div class="field mb-4 col-12">
              <label for="colour" class="font-medium">Colour</label>
              <br />
              <p-colorpicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="PackageObj.colour"></p-colorpicker>
              <input style="width:200px;" [(ngModel)]="PackageObj.colour" id="hexcolour" type="text" pInputText>
            </div>
            <div class="field mb-4 col-12">
              <label for="packageRule" class="font-medium">Public Deposit Policy</label>
              <p-select [options]="DepositPolicies" [(ngModel)]="PackageObj.publicDepositPolicy" placeholder="Please select a Deposit Policy" [showClear]="true" optionLabel="name"></p-select>
            </div>
            <!-- <div *ngIf="!publicDepositPolicy" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must have a Public Deposit Policy.</div> -->
            <div class="field mb-4 col-12">
              <label for="packageRule" class="font-medium">Venue Deposit Policy</label>
              <p-select [options]="DepositPolicies" [(ngModel)]="PackageObj.venueDepositPolicy" placeholder="Please select a Deposit Policy" [showClear]="true" optionLabel="name"></p-select>
            </div>
            <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;margin-bottom: 20px;">
              <div class="field mb-4 col-12">
                <label for="" class="font-medium">Tags</label>
                <br />
                <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="PackageObj.tags" display="chip">
                  <ng-template let-value #selecteditems>
                    @for (tag of PackageObj.tags; track tag) {
                      <span>
                        <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                        </p-chip>
                      </span>
                    }
                  </ng-template>
                </p-multiselect>
              </div>
            </div>
            <app-accordion style="background-color: white !important; margin-top: 5px; border: none;width:100%" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
              <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;;width:100%">
                <ng-template pTemplate="header">
                  <div style="width:100%">
                    <span class="pi pi-cog" style="margin-right: 10px;"></span>Advanced
                  </div>
                </ng-template>
                <div class="field mb-4 col-12">
                  <label for="packageRule" class="font-medium">Package Rule</label>
                  <p-select [options]="packageRules.data" [(ngModel)]="PackageObj.packageRule" [(ngModel)]="PackageObj.packageRule" placeholder="No Package Rule" [showClear]="true" optionLabel="name"></p-select>
                </div>
                <div class="field mb-4 col-12">
                  <label for="packageRule" class="font-medium">Booking Questionnaire</label>
                  <p-select [options]="BookingQuestionnaires" [(ngModel)]="PackageObj.questionnaire" placeholder="No Booking Questionnaire" [showClear]="true" optionLabel="name"></p-select>
                </div>
                <div class="field mb-4 col-12">
                  <label for="selectionmode" class="font-medium">Booking Timeout:</label>
                  <p-inputnumber  [(ngModel)]="BookingTimeout" [showButtons]="true" mode="decimal" buttonLayout="horizontal" min="5" max="30"></p-inputnumber>
                </div>
                <div class="field mb-4 col-12">
                  <label for="maxcalendarmonths" class="font-medium">Maximum number of months this package can be booked in advance:</label>
                  <p-inputnumber [(ngModel)]="maxcalendarmonths" [showButtons]="true" mode="decimal" buttonLayout="horizontal" min="1" max="18"></p-inputnumber>
                </div>
                <div style="clear:both;"></div>
                <div class="field mb-4 col-12">
                  <label for="pcannotbepaidwithvoucher" class="font-medium">Prevent Gift Vouchers being used with this Package:</label>
                  <p-selectbutton id="pcannotbepaidwithvoucher" [options]="stateOptions" [(ngModel)]="PackageObj.cannotbepaidwithvoucher" [style]="{'width': '300px'}" ></p-selectbutton>
                </div>
                <div style="clear:both;"></div>
                <div class="field mb-4 col-12">
                  <label for="quantity" class="font-medium">Add an early bird discount:</label>
                  <p-selectbutton id="pearlybird" [options]="stateOptions" [(ngModel)]="PackageObj.earlybirddiscount" [style]="{'width': '300px'}" ></p-selectbutton>
                </div>
                <div style="clear:both;"></div>
                @if (PackageObj.earlybirddiscount) {
                  <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                    <div class="field mb-4 col-12">
                      <label for="venueclosingstartdate">Is this discount to be applied between specific dates or for a number of days before?</label>
                      <p-selectbutton [style]="{'width': '450px'}" [options]="stateOptionsRangeType" [(ngModel)]="PackageObj.discountrangetype" ></p-selectbutton>
                    </div>
                    <div class="field mb-4 col-12">
                      <label for="venueclosingstartdate">Discount type</label>
                      <p-selectbutton [style]="{'width': '450px'}" [options]="stateOptions3" [(ngModel)]="PackageObj.discounttype" ></p-selectbutton>
                    </div>
                    @if (PackageObj.discounttype == 'FIXED') {
                      <div class="field mb-4 col-12">
                        <label for="eventEarlybirdDiscountAmount" class="font-medium">Discount Amount</label>
                        <p-inputnumber id="eventEarlybirdDiscountAmount" [style]="{'width': '300px'}" mode="currency" currency="{{CurrencySymbol}}" [(ngModel)]="PackageObj.discountamount" [showButtons]="true" max="10000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                      </div>
                    }
                    @if (PackageObj.discounttype == 'PERCENTAGE') {
                      <div class="field mb-4 col-12">
                        <label for="eventEarlybirdDiscountAmount" class="font-medium">Discount Amount</label>
                        <p-inputnumber id="eventEarlybirdDiscountAmount" [style]="{'width': '300px'}" suffix="%" [(ngModel)]="PackageObj.discountamount" [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                      </div>
                    }
                    @if (PackageObj.discountrangetype == 0) {
                      <div>
                        <div class="field mb-4 col-12">
                          <label for="eventEarlybirdDiscountStartDate" class="font-medium">Discount Start Date</label>
                          <p-datepicker [selectOtherMonths]="true" id="eventEarlybirdDiscountStartDate" [utc]="true" [style]="{'width': '300px'}" [(ngModel)]="PackageObj.discountstart" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="eventEarlybirdDiscountStartDate"></p-datepicker>
                        </div>
                        <div class="field mb-4 col-12">
                          <label for="eventEarlybirdDiscountEndDate" class="font-medium">Discount End Date</label>
                          <p-datepicker [selectOtherMonths]="true" id="eventEarlybirdDiscountEndDate" [utc]="true" [style]="{'width': '300px'}" [(ngModel)]="PackageObj.discountend" dateFormat="dd/mm/yy" [showIcon]="true" inputId="eventEarlybirdDiscountEndDate"></p-datepicker>
                        </div>
                      </div>
                    }
                    @if (PackageObj.discountrangetype == 1) {
                      <div>
                        <div class="field mb-4 col-12" style="margin-top:20px">
                          <label for="quantity" class="font-medium">Number of days before event the discount is active for</label>
                          <p-inputnumber [(ngModel)]="PackageObj.discountdaysbefore" [showButtons]="true" buttonLayout="horizontal" mode="decimal" min="0" max="365"></p-inputnumber>
                        </div>
                      </div>
                    }
                  </div>
                }
                <app-accordion style="background-color: white !important; margin-top: 5px; border: none;width:100%" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                  <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;;width:100%">
                    <ng-template pTemplate="header">
                      <div style="width:100%">
                        <span class="pi pi-calendar" style="margin-right: 10px;"></span>Booking Date Restriction
                      </div>
                    </ng-template>
                    <!-- <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left; margin-bottom:20px;"> -->
                    <div class="field mb-4 col-12">
                      <!-- <div style="margin-bottom: 10px;">
                      The following settings are copied from the default values in venue settings, However you can change them here by typing in new values.
                    </div> -->
                    <div class="field mb-4 col-12">
                      <label for="" class="font-medium">Bookings cannot be made within this much time, if the customer chose 3 hours, this would mean if a customer is trying to book for today then they would see time slots in 3 hours time even if you could fit them in sooner.</label>
                      <div style="width:54px; float: left; margin-top:13px;">Days</div><div style="float:left; width:190px;"><p-inputnumber id="BookingsCannotBeMadeWithinXMinutesD" [style]="{'width': '170px', 'float':'left'}" [(ngModel)]="bookingCannotBeMadeWithinXMinutesD" [showButtons]="true" max="365" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber></div>
                      <div style="width:61px; float: left; margin-top:13px;">Hours</div><div style="float:left; width:190px;"><p-inputnumber id="BookingsCannotBeMadeWithinXMinutesH" [style]="{'width': '170px', 'float':'left'}" [(ngModel)]="bookingCannotBeMadeWithinXMinutesH" [showButtons]="true" max="24" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber></div>
                      <div style="width:74px; float: left; margin-top:13px;">Minutes</div><div style="float:left; width:190px;"><p-inputnumber id="BookingsCannotBeMadeWithinXMinutesM" [style]="{'width': '170px', 'float':'left'}" [(ngModel)]="bookingCannotBeMadeWithinXMinutesM" [showButtons]="true" max="60" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber></div>
                    </div>
                    <div class="field mb-4 col-12" style="margin-top:20px;">
                      <label style="margin-top:20px;" for="" class="font-medium">Bookings cannot be made after this much time, if you chose 365 days, would mean if a customer is trying to book, they would not see this package if they pick a date which is more than 365 days from now.</label>
                      <!-- <p-inputnumber id="BookingsCannotBeMadeAfterXMinutes" [style]="{'width': '300px'}" [(ngModel)]="PackageObj.bookingscannotbemadeafterxminutes== null ? 0: PackageObj.bookingscannotbemadeafterxminutes" [showButtons]="true" max="525600" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber> -->
                      <div style="width:54px; float: left; margin-top:13px;">Days</div><div style="float:left; width:190px;"><p-inputnumber id="bookingscannotbemadeafterxDays" [style]="{'width': '170px', 'float':'left'}" [(ngModel)]="bookingscannotbemadeafterxDays" [showButtons]="true" max="365" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber></div>
                    </div>
                    <div style="clear:both;"></div>
                    <div class="field mb-4 col-12" style="margin-top:20px;">
                      <label for="" class="font-medium">Can bookings be made for today? (If 'no' bookings cannot be made for the current day regardless of the time of day)</label><br>
                      <p-selectbutton id="CannotMakeBookingsToday" [(ngModel)] = "PackageObj.cannotmakebookingstoday" [style]="{'width': '150px'}" [options]="delayBookingStateOptions" ></p-selectbutton>
                    </div>
                  </div>
                <!-- </div> -->
                <div style="clear:both;"></div>
              </app-accordiontab>
            </app-accordion>
            <div style="clear:both;"></div>
          </app-accordiontab>
        </app-accordion>
        @if (this.id == '0') {
          <div>
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="NextRes()" style="margin-top: 24px !important; margin-bottom: -25px;"> Next <span class="pi pi-angle-right"></span></button> &nbsp;
            <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()" style="margin-top: 24px !important; margin-bottom: -25px;"> <span class="pi pi-times" style="margin-right:8px;"></span> Cancel </button>
          </div>
        }
      </app-tabpanel>
      <app-tabpanel header="Resources" leftIcon="pi pi-clone">
        <div class="surface-card p-4 shadow-2 border-round cf-picker" style="display:grid; grid-template-columns: minmax(0, 1fr) minmax(0, 2fr); gap:16px; align-items:start;">
          @if (!isMobile) {
            <div class="drag-column">
              <h5> Available Resources </h5>
              <p-table [value]="availableResources">
                <ng-template #header>
                  <tr>
                    <th style="width:90%">Name</th>
                    <th>&nbsp;</th>
                    <th>&nbsp;</th>
                  </tr>
                </ng-template>
                <ng-template #body let-resource>
                  <tr>
                    @if (!resource.isresourcecontainer) {
                      <td><span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}</td>
                    }
                    @if (resource.isresourcecontainer && !resource.isconstructed) {
                      <td><span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}</td>
                    }
                    @if (resource.isresourcecontainer && resource.isconstructed) {
                      <td><span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}</td>
                    }
                    <td>&nbsp;</td>
                    <td>
                      <button pButton pRipple type="button" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToResources(resource)">
                        <span class="pi pi-angle-right"></span>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <!--<div *ngIf="availableResources.length == 0" style="padding: 15px;">
              <i>No resources available</i>
            </div>-->
          </div>
        }
        <!-- On a phone the Available list is this dropdown instead, so the selected resources
        get the whole width. -->
        @if (isMobile) {
          <div class="cf-add-row">
            <p-select [options]="availableResources" [(ngModel)]="resourceToAdd" optionLabel="name" placeholder="Add a resource"
            [filter]="true" filterBy="name" appendTo="body" emptyMessage="No resources available"></p-select>
            <button pButton pRipple type="button" class="p-button-success"
              [disabled]="resourceToAdd == null" (click)="addChosenResource()"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
            </div>
          }
          <div class="drop-column" pDroppable="resources">
            <h5> Selected Resources </h5>
            <p-table styleClass="cf-panel-list" [value]="PackageObj.resources">
              <ng-template #body let-resource let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index">
                  <td class="cf-handle">
                    <span class="pi pi-bars" pReorderableRowHandle></span>
                  </td>
                  <td>
                    <app-accordion style="background-color: white !important; margin-top: 5px; border: none;" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                      <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;">
                        <ng-template pTemplate="header">
                          @if (!resource.isresourcecontainer) {
                            <div style="width:100%">
                              <span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}&nbsp;(Length:{{resource.length}}&nbsp;{{resource.exclusive? ", Exclusive": ""}})
                            </div>
                          }
                          @if (resource.isresourcecontainer && !resource.isconstructed) {
                            <div style="width:100%">
                              <span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}
                            </div>
                          }
                          @if (resource.isresourcecontainer && resource.isconstructed) {
                            <div style="width:100%">
                              <span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}
                            </div>
                          }
                        </ng-template>
                        <div class="surface-card p-4 shadow-2 border-round">
                          <div class="grid formgrid p-fluid">
                            <div class="field mb-4 col-12">
                              <label for="selectionmode" class="font-medium">Mode:</label>
                              <p-selectbutton id="selectionmode" [options]="stateOptionsComplexSimple" [(ngModel)]="resource.mode" ></p-selectbutton>
                            </div>
                            <div class="field mb-4 col-12">
                              <label for="selectionmode" class="font-medium">Length:</label>
                              <p-inputnumber inputId="rlen{{index}}" [(ngModel)]="PackageObj.resources[index].length" [showButtons]="true" mode="decimal" buttonLayout="horizontal"></p-inputnumber>
                            </div>
                            <div class="field mb-4 col-12">
                              <label for="selectionmode" class="font-medium">Exclusivity:</label>
                              <p-selectbutton  [options]="stateOptionsRes" [(ngModel)]="PackageObj.resources[index].exclusive"></p-selectbutton>
                            </div>
                            @if (resource.mode=='COMPLEX') {
                              <div>
                                @if (resource.isconstructed) {
                                  <div>
                                    <div class="field mb-4 col-12">
                                      <label for="selectionmode" class="font-medium">Select if the customer selects from a list or any of the available resources or if the system chooses it for them.</label>
                                      <p-selectbutton id="selectionmode" class="cf-stack" [options]="stateOptionsSel" [(ngModel)]="resource.selectionmode" ></p-selectbutton>
                                    </div>
                                    @if (resource.selectionmode == 'LIST' || resource.selectionmode == 'SYSTEMLIST') {
                                      <div class="field mb-4 col-12">
                                        <label for="selectionmode" class="font-medium">Choose Selectable Resourses</label>
                                        <p-table [value]="resource.resources"
                                          [(selection)]="resource.selectableresourcestrings" dataKey="resourceId">
                                          <ng-template #header>
                                            <tr>
                                              <th>&nbsp;</th>
                                              <th style="width: 40%;">Name</th>
                                              <th style="width: 27%;">&nbsp;</th>
                                              <th style="width: 33%;">&nbsp;</th>
                                            </tr>
                                          </ng-template>
                                          <ng-template #body let-selResources>
                                            <tr>
                                              <td>
                                                <p-tablecheckbox [value]="selResources"></p-tablecheckbox>
                                              </td>
                                              <td>
                                                {{selResources.name}}
                                              </td>
                                              <td>
                                                <!--<p-inputnumber inputId="rlen{{index}}"[(ngModel)]="selResources.length" [showButtons]="true" mode="decimal" buttonLayout="horizontal"></p-inputnumber>-->
                                              </td>
                                              <td>
                                                <!--<p-inputnumber inputId="rprice{{index}}" [(ngModel)]="selResources.price" [showButtons]="true" mode="currency" currency="{{CurrencySymbol}}" buttonLayout="horizontal"></p-inputnumber>-->
                                              </td>
                                            </tr>
                                          </ng-template>
                                        </p-table>
                                      </div>
                                    }
                                  </div>
                                }
                                <div class="field mb-4 col-12">
                                  <label for="ResourceStart" class="font-medium">Is this resource offset? (does it run at the sametime as other resources but may start a number of minutes after the start of the booking)</label>
                                  <p-selectbutton id="ResourceStart"  [options]="stateOptionsBool" [(ngModel)]="resource.inline" ></p-selectbutton>
                                </div>
                                @if (!resource.inline) {
                                  <div>
                                    <div class="field mb-4 col-12">
                                      <label for="ResourceStart" class="font-medium">When does this Resource start? ('At Start' will start this resource at the start of the booking, 'At End' will start this resource at the end of the booking and Offset will start the resource a number of minutes either negative or positive after the start of the booking e.g -10 minutes would start the resource 10 minutes before the booking starts.)</label>
                                      <p-selectbutton id="ResourceStart"  [options]="stateOptionsStart" [(ngModel)]="resource.startwhen"></p-selectbutton>
                                    </div>
                                    @if (resource.startwhen == 'OFFSET') {
                                      <div class="field mb-4 col-12">
                                        <label for="quantity" class="font-medium">Offset in number of minutes</label>
                                        <p-inputnumber id="quantity" [ngModel]="resource.startTimeOffset== null ? 1: resource.startTimeOffset" (ngModelChange)="resource.startTimeOffset = $event" [showButtons]="true" max="420" min="-420" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                      </div>
                                    }
                                    @if (resource.startwhen != 'OFFSET') {
                                      <div class="field mb-4 col-12">
                                        <label style="display:none;" for="quantity" class="font-medium">Offset in number of minutes</label>
                                        <p-inputnumber style="display:none;" id="quantity" [ngModel]="resource.startTimeOffset== null ? 1: resource.startTimeOffset" (ngModelChange)="resource.startTimeOffset = $event" [showButtons]="true" max="420" min="-420" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                      </div>
                                    }
                                  </div>
                                }
                                <div class="field mb-4 col-12">
                                  <label for="ResourceOpt" class="font-medium">Is this Resource optional?</label>
                                  <p-selectbutton id="ResourceOpt"  [options]="stateOptions" [(ngModel)]="resource.optional" ></p-selectbutton>
                                </div>
                                <div class="field mb-4 col-12">
                                  <label for="QuantityMode" class="font-medium">Will this resource be for the whole group, just those participating or should the customer choose</label>
                                  <p-selectbutton id="QuantityMode"  [options]="stateOptionsQty" [(ngModel)]="resource.quantityselector" ></p-selectbutton>
                                </div>
                                <!--<div *ngIf="resource.quantityselector !='GROUPSIZE' && resource.quantityselector !='PARTICIPANT'" class="field mb-4 col-12">
                                <label for="quantity" class="font-medium">Quantity</label>
                                <p-inputnumber id="quantity" [(ngModel)]="resource.quantity== null ? 1: resource.quantity" [showButtons]="true" max="999" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>-->
                              <div style="display:none">
                                <div class="field mb-4 col-12">
                                  <label for="quantity" class="font-medium">Price:</label>
                                  <p-inputnumber  [(ngModel)]="resource.price" [showButtons]="true" buttonLayout="horizontal" mode="currency" currency="{{CurrencySymbol}}"></p-inputnumber>
                                </div>
                                <div class="field mb-4 col-12">
                                  <label for="QuantityMode" class="font-medium">Is this price fixed or per person?</label>
                                  <p-selectbutton id="PriceMode"  [options]="stateOptionsPrice" [(ngModel)]="resource.fixedprice" ></p-selectbutton>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </app-accordiontab>
                  </app-accordion>
                </td>
                <td>
                  <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromResources(resource)">
                    <span class="pi pi-angle-left"></span>
                  </button>
                </td>
                <td class="row-move-cell"><app-row-move [list]="PackageObj.resources" [index]="index"></app-row-move></td>
              </tr>
            </ng-template>
          </p-table>
          <div class="surface-card p-4 shadow-2 border-round">
            <div>
              <b>Example Itinerary</b>
              <br />
              {{itinerary}}<br>
              @for (item of discrepantitinerary; track item) {
                <span>{{item}}</span>
              }
              <div>
                <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="buildItinerary()">
                  <span style="margin-right:10px;" class="pi pi-refresh"></span>
                  Refresh Itinerary
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (this.id == '0') {
        <div>
          <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="NextAds()" style="margin-top: 24px !important; margin-bottom: -25px;"> Next <span class="pi pi-angle-right"></span></button> &nbsp;
          <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()" style="margin-top: 24px !important; margin-bottom: -25px;"> <span class="pi pi-times" style="margin-right:8px;"></span> Cancel </button>
        </div>
      }
    </app-tabpanel>
    <app-tabpanel header="Admissions" leftIcon="pi pi-users">
      <div class="surface-card p-4 shadow-2 border-round cf-picker" style="display:grid; grid-template-columns: minmax(0, 1fr) minmax(0, 2fr); gap:16px; align-items:start;">
        @if (!isMobile) {
          <div class="drag-column">
            <h5> Available Admissions </h5>
            <p-table [value]="availableAdmissions">
              <ng-template #header>
                <tr>
                  <th style="width: 90%;">Name</th>
                  <th>&nbsp;</th>
                </tr>
              </ng-template>
              <ng-template #body let-admission>
                <tr>
                  <td><span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}}</td>
                  <td>
                    <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToAdmissions(admission)">
                      <span class="pi pi-angle-right"></span>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            @if (availableAdmissions.length == 0) {
              <div style="padding: 15px;">
                <i>No admissions available</i>
              </div>
            }
          </div>
        }
        <!-- On a phone the Available list is this dropdown instead, so the selected admissions
        get the whole width. -->
        @if (isMobile) {
          <div class="cf-add-row">
            <p-select [options]="availableAdmissions" [(ngModel)]="admissionToAdd" optionLabel="name" placeholder="Add an admission"
            [filter]="true" filterBy="name" appendTo="body" emptyMessage="No admissions available"></p-select>
            <button pButton pRipple type="button" class="p-button-success"
              [disabled]="admissionToAdd == null" (click)="addChosenAdmission()"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
            </div>
          }
          <div class="drop-column" pDroppable="admissions">
            <h5> Selected Admissions </h5>
            <p-table styleClass="cf-panel-list" [value]="PackageObj.admissions">
              <ng-template #header let-columns>
                <tr>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th class="row-move-cell"></th>
                </tr>
              </ng-template>
              <ng-template #body let-admission let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index">
                  <td class="cf-handle">
                    <span class="pi pi-bars" pReorderableRowHandle></span>
                  </td>
                  <td>
                    <app-accordion style="background-color: white !important; margin-top: 5px; border: none;" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                      <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;">
                        <ng-template pTemplate="header">
                          <div style="width:100%">
                            <span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}} &nbsp;(Min:&nbsp;{{admission.min}},&nbsp;Max:&nbsp;{{admission.max}},&nbsp;Price:&nbsp;{{admission.price | currency:this.CurrencySymbol}})
                          </div>
                        </ng-template>
                        <div class="surface-card p-4 shadow-2 border-round">
                          <div class="grid formgrid p-fluid">
                            <div class="field mb-4 col-12">
                              <label for="ResourceStart" class="font-medium">Booking Wizard Text</label>
                              <input [(ngModel)]="admission.bookingwizardtext" id="classname" type="text" pInputText>
                            </div>
                            <div class="field mb-4 col-12">
                              <label for="quantity" class="font-medium">Minimum</label>
                              <p-inputnumber [(ngModel)]="admission.min" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                            </div>
                            <div class="field mb-4 col-12">
                              <label for="ResourceOpt" class="font-medium">Maximum</label>
                              <p-inputnumber [(ngModel)]="admission.max" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                            </div>
                            <div class="field mb-4 col-12">
                              <label for="quantity" class="font-medium">Price:</label>
                              <p-inputnumber  [(ngModel)]="admission.price" [showButtons]="true" buttonLayout="horizontal" mode="currency" currency="{{CurrencySymbol}}"></p-inputnumber>
                            </div>
                            <!--advanced-->
                            <app-accordion style="background-color: white !important; margin-top: 5px; border: none;width:100%" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                              <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;;width:100%">
                                <ng-template pTemplate="header">
                                  <div style="width:100%">
                                    <span class="pi pi-cog" style="margin-right: 10px;"></span>Advanced
                                  </div>
                                </ng-template>
                                <div class="field mb-4 col-12">
                                  <label for="QuantityMode" class="font-medium">Must Include:</label>
                                  <p-selectbutton id="pmi"  [options]="stateOptionsMI" [(ngModel)]="admission.mustinclude" ></p-selectbutton>
                                </div>
                                <div class="field mb-4 col-12">
                                  <label for="quantity" class="font-medium">Does this count towards the overall min number on this package:</label>
                                  <p-selectbutton id="ppp" [options]="stateOptions" [(ngModel)]="admission.countstowardsmin" ></p-selectbutton>
                                </div>
                                @if (!admission.countstowardsmin) {
                                  <div class="field mb-4 col-12">
                                    <label for="packageobjname" class="font-medium">Please enter a message explaining how the minimum number of people is calculated without this admission.</label>
                                    <div style="clear:both;"></div>
                                    <input [(ngModel)]="admission.message" type="text" pInputText>
                                  </div>
                                }
                                @if (!admission.countstowardsmin && (admission.message == null || admission.message == '')) {
                                  <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a message if this admission does not count towards the minimum numbers.</div>
                                }
                                <!-- <div class="field mb-4 col-12">
                                <label for="quantity" class="font-medium">Does this count towards the overall max number on this package:</label>
                                <p-selectbutton id="ppp" [options]="stateOptions" [(ngModel)]="admission.countstowardsmax" ></p-selectbutton>
                              </div> -->
                              <div class="field mb-4 col-12">
                                <label for="QuantityMode" class="font-medium">Class:</label>
                                <p-select [options]="classes" [(ngModel)]="admission.admissionClass" placeholder="No Class" [showClear]="true" optionLabel="name"></p-select>
                              </div>
                              <div class="field mb-4 col-12">
                                <label for="quantity" class="font-medium">Participant:</label>
                                <p-selectbutton id="ppar" [options]="stateOptionsPart" [(ngModel)]="admission.participant" ></p-selectbutton>
                              </div>
                              <div class="field mb-4 col-12">
                                <label for="quantity" class="font-medium">Price:</label>
                                <p-selectbutton id="ppp" [options]="stateOptionsPPP" [(ngModel)]="admission.fixedPrice" ></p-selectbutton>
                              </div>
                              <div class="field mb-4 col-12">
                                <label for="quantity" class="font-medium">Do you want to link any admissions?:</label>
                                <p-selectbutton id="ppp" [options]="stateOptions" [(ngModel)]="admission.uselinkedadmissions" ></p-selectbutton>
                              </div>
                              @if (admission.uselinkedadmissions) {
                                <div style="margin-bottom:20px;" class="surface-card p-4 shadow-2 border-round">
                                  @if (admission.uselinkedadmissions) {
                                    <div   class="field mb-4 col-12" style="margin-top:20px;">
                                      <label for="quantity" class="font-medium">Would you like to only set the maximum of this admission based on the linked admissions:</label>
                                      <p-selectbutton id="ppp" [options]="stateOptions" [(ngModel)]="admission.onlysetmax" ></p-selectbutton>
                                    </div>
                                  }
                                  <div style="width:100%;">
                                    <div style="float:left; width:87%;">
                                      <p-select [options]="PackageObj.admissions" [(ngModel)]="CurrentSelectedLinkedAdmission" placeholder="Please select as Admission" [showClear]="true" optionLabel="name"></p-select>
                                    </div>
                                    <div style="float:left; width:3%;">
                                      &nbsp;
                                    </div>
                                    <div style="float:left; width:10%;">
                                      <button pButton pRipple type="button" style="margin-bottom: 10px;margin-top: 0px !important;height: 50px;" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="addAdmissionToLinked(admission)">
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                  <div style="clear:both;"></div>
                                  <div>
                                    <p-table [value]="admission.linkedadmissions">
                                      <ng-template #header>
                                        <tr>
                                          <th style="width: 95%;">Name</th>
                                          <!-- <th style="width: 20%;">Threshold</th> -->
                                          <th style="width: 5%;">&nbsp;</th>
                                        </tr>
                                      </ng-template>
                                      <ng-template #body let-linkedadmissions>
                                        <tr>
                                          <td><span class="pi pi-user" style="margin-right: 10px;"></span>{{linkedadmissions.admissionname}}</td>
                                          <!-- <td>
                                          <p-inputnumber min="1" max="10000"  [(ngModel)]="linkedadmissions.threshold" [style]="{width: '162px'}" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                                        </td> -->
                                        <td>
                                          <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeLinkedAdmission(linkedadmissions)">
                                            <span class="pi pi-trash"></span>
                                          </button>
                                        </td>
                                      </tr>
                                    </ng-template>
                                  </p-table>
                                </div>
                              </div>
                            }
                            <div class="field mb-4 col-12">
                              <label for="quantity" class="font-medium">Do you want to link any admissions for a discount?:</label>
                              <p-selectbutton id="ppp" [options]="stateOptions" [(ngModel)]="admission.uselinkeddiscounts" ></p-selectbutton>
                            </div>
                            @if (admission.uselinkeddiscounts) {
                              <div class="surface-card p-4 shadow-2 border-round">
                                @if (admission.uselinkeddiscounts) {
                                  <div style="width:100%;">
                                    <div style="float:left; width:87%;">
                                      <p-select [options]="PackageObj.admissions" [(ngModel)]="CurrentSelectedAdmission" placeholder="Please select as Admission" [showClear]="true" optionLabel="name"></p-select>
                                    </div>
                                    <div style="float:left; width:3%;">
                                      &nbsp;
                                    </div>
                                    <div style="float:left; width:10%;">
                                      <button pButton pRipple type="button" style="margin-bottom: 10px;margin-top: 0px !important;height: 50px;" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="addAdmissionToLinkedDiscount(admission)">
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                }
                                <div style="clear:both;"></div>
                                @if (admission.uselinkeddiscounts) {
                                  <div >
                                    <p-table [value]="admission.linkeddiscounts">
                                      <ng-template #header>
                                        <tr>
                                          <th style="width: 55%;">Name</th>
                                          <th style="width: 2%;">Discount</th>
                                          <th style="width: 20%;">Threshold</th>
                                          <th style="width: 5%;">&nbsp;</th>
                                        </tr>
                                      </ng-template>
                                      <ng-template #body let-linkeddiscounts>
                                        <tr>
                                          <td><span class="pi pi-user" style="margin-right: 10px;"></span>{{linkeddiscounts.admissionname}}</td>
                                          <td>
                                            <p-inputnumber min="1" max="100" [(ngModel)]="linkeddiscounts.percentagediscount" suffix="%" [style]="{width: '162px'}" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                                          </td>
                                          <td>
                                            <p-inputnumber min="1" max="10000"  [(ngModel)]="linkeddiscounts.threshold" [style]="{width: '162px'}" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                                          </td>
                                          <td>
                                            <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeLinkedDiscountAdmission(linkeddiscounts)">
                                              <span class="pi pi-trash"></span>
                                            </button>
                                          </td>
                                        </tr>
                                      </ng-template>
                                    </p-table>
                                    <!-- <div class="field mb-4 col-12" style="margin-top:20px;">
                                    <label for="quantity" class="font-medium">Maximum number of linked discounts:</label>
                                    <p-inputnumber  [(ngModel)]="admission.maxlinkeddiscounts" [showButtons]="true" buttonLayout="horizontal" mode="decimal" min="1" max="100"></p-inputnumber>
                                  </div> -->
                                </div>
                              }
                            </div>
                          }
                        </app-accordiontab>
                      </app-accordion>
                    </div>
                  </div>
                </app-accordiontab>
              </app-accordion>
            </td>
            <td>
              <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromAdmissions(admission)">
                <span class="pi pi-angle-left"></span>
              </button>
            </td>
            <td class="row-move-cell"><app-row-move [list]="PackageObj.admissions" [index]="index"></app-row-move></td>
          </tr>
        </ng-template>
      </p-table>
      <!--<div *ngIf="selectedAdmissions.length == 0" style="padding: 15px;">
      <i>No admissions selected, drag some here.</i>
    </div>-->
  </div>
</div>
<br>
  <div class="field mb-4 col-12">
    <label for="selectionmode" class="font-medium">Minimum Group Size:</label>
    <p-inputnumber inputId="min" [ngModel]="PackageObj.min" (ngModelChange)="onMinChange($event)" [showButtons]="true" mode="decimal" buttonLayout="horizontal"></p-inputnumber>
  </div>
  <div class="field mb-4 col-12">
    <label for="selectionmode" class="font-medium">Maximum Group Size:</label>
    <p-inputnumber inputId="max" [ngModel]="PackageObj.max" (ngModelChange)="onMaxChange($event)" [showButtons]="true" mode="decimal" buttonLayout="horizontal"></p-inputnumber>
  </div>
  @if (!maxNotLessThanMinValid) {
    <div class="text-danger" style="margin-left:10px; margin-top:-10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Maximum Group Size cannot be less than Minimum Group Size.</div>
  }
  @if (this.id == '0') {
    <div>
      <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData()" style="margin-top: 24px !important; margin-bottom: -25px;"> Save Changes <span class="pi pi-angle-right"></span></button> &nbsp;
      <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()" style="margin-top: 24px !important; margin-bottom: -25px;"> <span class="pi pi-times" style="margin-right:8px;"></span> Cancel </button>
    </div>
  }
</app-tabpanel>
</app-tabview>
</div>
</div>
@if (this.id != '0') {
  <div class="col-12">
    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData()"><span class="pi pi-pencil" style="margin-right:8px;"></span> Save Changes </button> &nbsp;
    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()"> <span class="pi pi-times" style="margin-right:8px;"></span> Cancel </button>
  </div>
}
</div>
<style>
  :host ::ng-deep .p-chip.custom-chip {
  background: var(--primary-color);
  color: var(--primary-color-text);
}
</style>
<!-- Closes the outer div, which was left open (Angular closed it implicitly here) -->
</div>
}
